import { render } from "./Milestone.vue?vue&type=template&id=d2c2d0dc&scoped=true"
import script from "./Milestone.vue?vue&type=script&lang=js"
export * from "./Milestone.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d2c2d0dc"

export default script